module.exports = __webpack_public_path__ + "static/media/imageForm.4b1076fc.png";